<template>
  <div class="withdrawInfo">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">充提系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>提币链信息提示</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-actions" style="margin-top: 10px">
      <el-select v-model="chainName" placeholder="请选择链名称">
        <el-option v-for="(item, index) in options" :key="index" :label="item" :value="item"></el-option>
      </el-select>
      <el-button type="primary" @click="getList">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>
    <div class="page-actions" style="margin-top: 10px">
      <el-button type="primary" @click="add">新增</el-button>
    </div>
    <el-card class="page-content" shadow="never">
      <div class="list">
        <el-table :data="infoListData" border style="width: 100%">
          <el-table-column prop="chainName" label="链名称" />
          <el-table-column prop="chainFullName" label="英文全称" />
          <el-table-column prop="arriveTime" label="预估到账时间（分钟）" />
          <el-table-column prop="blindBoxName" label="提现提示（中文）" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.nameObj" :key="index">
                <span v-if="item.lang === 'zh'">{{ item.name }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="blindBoxName" label="提现提示（英文）" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.nameObj" :key="index">
                <span v-if="item.lang === 'en'">{{ item.name }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="blindBoxName" label="提现提示（韩文）" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.nameObj" :key="index">
                <span v-if="item.lang === 'kr'">{{ item.name }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="blindBoxName" label="提现提示（越南语）" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.nameObj" :key="index">
                <span v-if="item.lang === 'vi'">{{ item.name }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.state !== 1"
                @click="editItem(scope.row)"
                type="primary"
                size="mini"
                plain
              >编辑</el-button>
              <el-button
                v-if="scope.row.state !== 1"
                @click="delItem(scope.row)"
                type="danger"
                size="mini"
                plain
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="total"
        @pageChanged="handlePageChanged"
      ></pagination>
    </el-card>
    <el-dialog
      class="editBox"
      :title="title"
      :visible.sync="boxShow"
      width="700px"
      :before-close="closeBox"
    >
      <el-form :model="form" ref="form" :rules="rules" label-width="145px" :disabled="isFind">
        <el-form-item label="语言" prop="languageObj">
          <el-checkbox-group v-model="form.languageObj" @change="$forceUpdate()">
            <el-checkbox
              v-for="lang in languages"
              :label="lang.value"
              :key="lang.value"
            >{{lang.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="链名称" prop="chainName">
          <el-select v-model="form.chainName" placeholder="请选择链名称">
            <el-option v-for="(item, index) in options" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="英文全称" prop="chainFullName">
          <el-input v-model.number="form.chainFullName" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="预估到账时间" prop="arriveTime">
          <el-input v-model.number="form.arriveTime" maxlength="4">
            <i slot="suffix">分钟</i>
          </el-input>
        </el-form-item>
        <el-form-item label="提现提示语" prop="tipsObj" style="margin-top: 20px">
          <span class="star">*</span>
          <div
            v-for="lang in form.languageObj"
            :key="lang"
            style="display: inline-block; margin-bottom: 10px;"
          >
            <el-input
              :value="tipsObj[lang]"
              maxlength="50"
              class="width300"
              :rules="[{ required: true, message: '提示语不能为空'}]"
              :placeholder="languagesObj[lang]+'提示语'"
              @change="tipsObjChange(lang, $event)"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div v-if="!isFind" slot="footer" class="dialog-footer">
        <el-button @click="closeBox">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import LANGUAGES from "../../../common/languages_code";
import Pagination from "../../../components/pagination";
import api from "./api";
import "./store";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      chainName: "",
      options: [],
      languagesObj: LANGUAGES,
      languages: Object.keys(LANGUAGES).map(lang => ({
        label: LANGUAGES[lang],
        value: lang
      })),
      title: "新增",
      boxShow: false,
      form: {
        arriveTime: "",
        chainFullName: "",
        chainName: "",
        languageObj: ["zh"]
      },
      tipsObj: {},
      tips: "",
      rules: {
        languageObj: [{ required: true, message: "请选择语言" }],
        chainName: [
          { required: true, message: "请选择链名称", trigger: "change" }
        ],
        chainFullName: [
          { required: true, message: "请输入英文全称", trigger: "blur" }
        ],
        arriveTime: [
          { required: true, message: "请输入预估到账时间", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "到账时间不能超过1000分钟",
            trigger: "blur"
          }
        ]
      },
      isFind: false,
      isEdit: false
    };
  },
  computed: {
    ...mapState("withdrawInfo", ["infoListData", "pagination", "total"])
  },
  methods: {
    ...mapActions("withdrawInfo", ["getinfoList"]),
    reset() {
      this.chainName = "";
      this.getList();
    },
    getChainList() {
      api.getChain().then(res => {
        this.options = res.data;
      });
    },
    getList(data = {}) {
      this.getinfoList({
        chainName: this.chainName,
        ...this.pagination,
        ...data
      });
    },
    handlePageChanged(pageVal) {
      this.getList(pageVal);
    },
    tipsObjChange(lang, value) {
      this.tipsObj[lang] = value;
      this.tips = JSON.stringify(this.tipsObj);
      //   this.$forceUpdate();
    },
    add() {
      this.boxShow = true;
      this.title = "新增";
      this.isEdit = false;
    },
    editItem(row) {
      this.boxShow = true;
      this.title = "编辑";
      this.isEdit = true;
      this.form.arriveTime = row.arriveTime;
      this.form.chainFullName = row.chainFullName;
      this.form.chainName = row.chainName;
      this.form.languageObj = row.languageObj;
      this.form.id = row.id;
      this.tipsObj = row.tipsObj;
    },
    delItem(row) {
      this.$confirm("删除后不可恢复，是否确认将此条数据删除？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      }).then(() => {
        api.deleteInfo(row.id).then(res => {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getList();
        });
      });
    },
    closeBox() {
      this.boxShow = false;
      this.isFind = false;
      this.isEdit = false;
      // 清空表单数据
      this.$refs["form"].resetFields();
      this.form = {};
      this.tipsObj = {};
      this.form.languageObj = ["zh"];
    },
    submitForm(formName) {
      if (
        Object.keys(this.tipsObj).length <
          Object.keys(this.form.languageObj).length ||
        !this.tipsObj[this.form.languageObj[0]]
      ) {
        return this.$message({
          message: "请输入提现提示信息",
          type: "error"
        });
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            arriveTime: this.form.arriveTime,
            chainFullName: this.form.chainFullName,
            chainName: this.form.chainName,
            id: this.form.id,
            withdrawPrompt: JSON.stringify(this.tipsObj)
          };
          api.addOrUpdate(data).then(res => {
            this.$message({
              message: "提交成功",
              type: "success"
            });
            this.boxShow = false;
            this.getList();
            this.$refs["form"].resetFields();
            this.form = {};
            this.nameObj = {};
            this.form.languageObj = ["zh"];
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  created() {
    this.getChainList();
    this.getList();
  }
};
</script>
<style lang="less">
.withdrawInfo {
  .page-actions {
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .star {
    position: absolute;
    left: -91px;
    color: #f56c6c;
  }
  .editBox {
    .el-input {
      width: 200px;
    }
    .el-input__inner {
      width: 200px;
    }
    .el-input.width300 {
      width: 450px;
      .el-input__inner {
        width: 100%;
      }
    }
  }
}
</style>